var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

function buildKey(path) {
  return path.reduce(function (result, chunk, index) {
    return index === 0 ? chunk : "".concat(result, "[").concat(chunk, "]");
  }, '');
}

export function buildNormalizedParams(input, path) {
  if (path === void 0) {
    path = [];
  }

  var result = [];

  for (var _i = 0, _a = Object.entries(input); _i < _a.length; _i++) {
    var _b = _a[_i],
        key = _b[0],
        value = _b[1];

    if (typeof value === 'number' || typeof value === 'string') {
      result.push([buildKey(__spreadArray(__spreadArray([], path, true), [key], false)), value.toString()]);
    } else if (value === true) {
      result.push([buildKey(__spreadArray(__spreadArray([], path, true), [key], false)), 'true']);
    } else if (value === false) {
      result.push([buildKey(__spreadArray(__spreadArray([], path, true), [key], false)), 'false']);
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        for (var _c = 0, value_1 = value; _c < value_1.length; _c++) {
          var innerValue = value_1[_c];
          result.push(["".concat(buildKey(__spreadArray(__spreadArray([], path, true), [key], false)), "[]"), innerValue.toString()]);
        }
      } else if (value) {
        for (var _d = 0, _e = buildNormalizedParams(value, __spreadArray(__spreadArray([], path, true), [key], false)); _d < _e.length; _d++) {
          var param = _e[_d];
          result.push(param);
        }
      }
    }
  }

  return result;
}